import { GetServerSidePropsContext } from 'next'
import { useTranslation } from 'next-i18next'
import { useState, useEffect } from 'react'
import Head from 'next/head'
import { useRouter } from 'next/router'

import SearchNearParking from '@/components/home/SearchNearParking/SearchNearParking'
import { loadTranslationsWithMarket } from '@/utils/loadTranslations'
import HeroSearchResults from '@/components/hero/HeroSearchResults'
import Spinner from '@/components/common/SpinnerPage'
import ResultsPage from '@/components/layouts/Results/Results'
import Meta from '@/components/Meta'
import SelectedCountryLocalized from '@/utils/selectedCountryLocalized'
import { getLocationContext, LocationContext } from '@/utils/getLocationContext'
import { useMarket } from '@/utils/multi-markets/context'

export const getServerSideProps = async (
  context: GetServerSidePropsContext
) => {
  const result = await loadTranslationsWithMarket(context, {
    cache: 'stale-while-revalidate',
    namespaces: ['home', 'common', 'opinions', 'parkings', 'popups', 'faq']
  })

  return result
}

export default function ParkingSearch() {
  const { t, ready } = useTranslation(['parkings', 'common'])
  const [parkingsCount, setParkingsCount] = useState<number | string>('...')
  const [locationContext, setLocationContext] = useState<
    LocationContext | undefined
  >()
  const router = useRouter()
  const { market } = useMarket()

  const marketCountry = SelectedCountryLocalized()

  useEffect(() => {
    if (router.isReady && router.query.locationLabel) {
      const context = getLocationContext(
        router.query.locationLabel as string,
        market
      )

      setLocationContext(context)
    }
  }, [router.isReady, router.query.locationLabel, market])

  const metaString = t('parkings:meta.availableParkingLots', {
    marketCountry: marketCountry,
    parkingsCount: parkingsCount ?? 0
  })

  if (!ready) {
    return <Spinner fullPage />
  }

  return (
    <>
      <Head>
        <meta name="theme-color" content="#093769" />
      </Head>
      <ResultsPage fullPage isButtonTop={false} isFooter={false}>
        <Meta
          title={metaString}
          description={t('parkings:meta.parkingSearch.description')}
        />
        <HeroSearchResults
          parkingsCount={parkingsCount}
          locationContext={locationContext}
        />
        <SearchNearParking setParkingsCount={setParkingsCount} />
        <div id="modal-search-mobile" />
      </ResultsPage>
    </>
  )
}
